export default {
    apiGetProfileAll(data = {}, urldata = {}) {
        let { limit = 10, order_by = "updatedAt", order_direction = "DESC", page = 1 } = data;
        let payload = {
            ...data,
            limit,
            order_by,
            order_direction,
            page
        }
        return this.request(this.api().getProfileAll, payload)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().get();
    },
    apiGetProfile(data = {}, urldata = {}) {
        return this.request(this.api().getProfile, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().get();
    },
    apiPutProfile(data = {}, urldata = {}) {
        return this.request(this.api().putProfile, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().get();
    },
    apiPatchProfile(data = {}, urldata = {}) {
        return this.request(this.api().patchProfile, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().get();
    },
    apiDeleteProfile(data = {}, urldata = {}) {
        return this.request(this.api().deleteProfile, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().get();
    },
    apiGetDocumentsAll() {
        return new Promise((resolve, reject) => {
            this.execApi('getDocumentsAll').then((response) => {
                resolve(response.data.map(o => ({
                    ...o,
                    doc_meta_name: (o.doc_meta_name ? o.doc_meta_name.decode().parse() : {}),
                    group: (o.doc_meta_name ? o.doc_meta_name.decode().parse().group : "ungroup")
                }
                )).group());
            }).catch(reject);
        })
    },
    apiGetApplicationDocumentsAll() {
        return new Promise((resolve, reject) => {
            this.execApi('getAllDocumentsByApplication').then((response) => {
                resolve(response.data.items.map(o => ({
                    ...o,
                    doc_meta_name: (o.doc_meta_name ? o.doc_meta_name.decode().parse() : {}),
                    group: (o.doc_meta_name ? o.doc_meta_name.decode().parse().group : "ungroup")
                }
                )).group());
            }).catch(reject);
        })
    },
    apiUploadDocument(file, application_id, doc_meta_name) {
        return new Promise((resolve, reject) => {
            this.api.execApi("postDocument", {
                file,
                doc_meta_name
            }, {
                application_id
            }, true)
            .then(resolve)
            .catch(reject);
        })

    },
    apiDeleteDocument(application_id) {
        return new Promise((resolve, reject) => {
            this.api.execApi("deleteDocument", {}, {
                application_id
            }, true)
            .then(resolve)
            .catch(reject);
        })
    },
    apiDownloadDocument(application_id) {
        return new Promise((resolve, reject) => {
            this.api.execApi("getDocument", {}, {
                application_id
            }, true)
            .then(resolve)
            .catch(reject);
        })
    }
}